<template>
  <ul class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="indexLink" class="nav-link text-white" active-class="active">Compras</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="remitosDeCompraLink" class="nav-link text-white" active-class="active">Remitos</router-link>
    </li>
    <v-guard :permissions="['PROVEEDORES']">
      <li class="nav-item">
        <router-link :to="proveedoresLink" class="nav-link text-white" active-class="active">Proveedores</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="transportesLink" class="nav-link text-white" active-class="active">Transportes</router-link>
    </li>
    <v-guard :permissions="['PROVEEDORES_CTA_CORRIENTE']">
      <li class="nav-item">
        <router-link :to="ccProveedoresLink" class="nav-link text-white" active-class="active">Cuenta corriente de proveedores</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="pagoAProveedoresLink" class="nav-link text-white" active-class="active">Pago a proveedores</router-link>
    </li>
    <BranchofficeSelect v-if="getHasPermission" />
  </ul>
</template>

<script>
import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";

export default {
  components: {
      BranchofficeSelect
  },
  data() {
    return {
      hasPermission : false
    }
  },
  computed: {
    getHasPermission() {
      return this.hasPermission
    },
    indexLink() {
      return { name: 'Compras' }
    },
    remitosDeCompraLink() {
      return { name: 'Remitos de compra' }
    },
    transportesLink() {
      return { name: 'Transportes' }
    },
    proveedoresLink() {
      return { name: 'Proveedores' }
    },
    ccProveedoresLink() {
      return { name: 'Cuenta corriente de proveedores' }
    },
    pagoAProveedoresLink() {
      return { name: 'Pago a proveedores' }
    },
    // dropdown nueva compra
  },
  methods: {
    getAllBranchofficesPermission() {
      this.$http
        .get("/api/configs/role/permissions/names", {
          headers: { 
            Authorization: "Bearer " + localStorage.getItem("token")
          },
        })
        .then((response) => {
          this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_PURCHASES');
        })
    },
  },
  created() {
    this.getAllBranchofficesPermission();
  },
}
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
  /* justify-content-start fijo (no solo mientras carga el selector de
     sucursal) para que no haya salto de layout al montar/desmontar. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>